import { render, staticRenderFns } from "./TicketGroups.vue?vue&type=template&id=b3e063d8&scoped=true"
import script from "./TicketGroups.vue?vue&type=script&lang=js"
export * from "./TicketGroups.vue?vue&type=script&lang=js"
import style0 from "./TicketGroups.vue?vue&type=style&index=0&id=b3e063d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e063d8",
  null
  
)

export default component.exports